module.exports = __webpack_public_path__ + "static/media/cofix.e9ad61c9.jpg";